import React from 'react';
import AsyncSelect from './asyncSelect';
import Modal from 'react-bootstrap/Modal';
import LoadingModal from '../../helpers/loadingModal';
import Lang from 'libraries/Lang';

let colourOptions = [];
let xhr = null;
const filterColors = (inputValue) => {
  if(colourOptions != null){
  return colourOptions.filter((i) =>
    i.label.toLowerCase().includes(inputValue.toLowerCase())
  );
  }
};

const promiseOptions = (inputValue) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(filterColors(inputValue));
    }, 1000);
  });


class CallCenterHeader extends React.Component {
  constructor(props) {
    super(props);

    const app = document.getElementById('app');
    const { language } = app.dataset;

    const urlArray = [
      '/',
      '/flights-promotion',
      '/travelgenie',
      '/hotel-deals',
      '/cars-promotion',
      '/cruise-deals',
      '/sunquest',
      '/add-ons',
      '/exotik-journeys',
      '/e-brochures',
      '/en',
      '/fr'
    ];

    this.state = {
      redirectedRoute: window.location.href,
      LanguageStatus: true,
      language: (language != undefined) ? language : 'en',
      Url: '',
      checked: true,
      agencyData: [],
      agentOptions: [],
      filterData: [],
      showModal: false,
      agentName: null,
      selectedAgent: null,
      organizationId: null,
      agencyId: null,
      agencyName: null,
      callCenterAgentName: null,
      commissionGroupCode: null,
      chain: null,
      loadingModel: false,
      loadData: true,
      showDimmer: true,
      showAgencySpan: false,
      showAgentSpan: false,
      chainName: null,
      agencyPIN: null,
      fopCreditCardOnly: false,
      packagURL: document.getElementById('packageUrl').value != null ? document.getElementById('packageUrl').value : '',
      token: null,
      travelbrandOrganizationId: document.getElementById('travelBrandsOrganization').value != null ? document.getElementById('travelBrandsOrganization').value : '',
      isRetreiveBooking: document.getElementById('isRetreiveBooking').value,
      urlArray: urlArray,
    }
    this.getAgencyData = this.getAgencyData.bind(this);
    this.getAgentData = this.getAgentData.bind(this);
    this.handleAgentChange = this.handleAgentChange.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.createAgentSession = this.createAgentSession.bind(this)
    this.onAgencyChange = this.onAgencyChange.bind(this)
    this.handleAgencySpanToggle = this.handleAgencySpanToggle.bind(this)
    this.resetAgentBooking = this.resetAgentBooking.bind(this)
  }


  componentDidMount() {

    // if(document.getElementById('baseUrl') != null && document.getElementById('baseUrl').value+'/' == document.referrer){
      const {
        pathname
      } = window.location;
      
    if(this.state.urlArray.includes(pathname)) {
      document.body.classList.add('overflow-hidden');
    } else if (this.state.isRetreiveBooking == 'Y' && this.state.showAgencySpan == false) {
      document.body.classList.add('overflow-visible');
    } else {
      document.body.classList.add('overflow-hidden');
    }
      const agentData = JSON.parse(this.props.agentData);

    if (agentData !== '' && agentData !== undefined && agentData.AgentSelected === 'Y') {
    
      this.setState({
        organizationId: agentData.OrganizationId ? agentData.OrganizationId : null,
        agencyId: agentData.Agency.id ? agentData.Agency.id : null,
        agencyPhone: agentData.Agency.phone ? agentData.Agency.phone : null,
        agencyName: agentData.AgencyName ? agentData.AgencyName : null,
        loadData: false,
        showDimmer: false,
        showAgencySpan: true,
        selectedAgent: {
          value: agentData.AgentId, label: `${agentData.Names.username} - ${agentData.Names.first} ${agentData.Names.last}`,
        // value: agentData.AgentId, label: `${agentData.Names.username.substring(0, agentData.Names.username.length / 2).replace(/./g,"*") + agentData.Names.username.substring(agentData.Names.username.length / 2, agentData.Names.username.length)} - ${agentData.Names.first} ${agentData.Names.last}`,
         commissionGroupCode: agentData.CommissionGroupCode ? agentData.CommissionGroupCode : null,
         chain: agentData.Chain ? agentData.Chain : null
        },
        agencyPIN: agentData.AgencyPIN ? agentData.AgencyPIN : null,
        chainName: agentData.Chain?.name ? agentData.Chain?.name : null,
        showAgentSpan: agentData.AgentId ? true : false,
        fopCreditCardOnly: agentData.FopCreditCardOnly === true ? agentData.FopCreditCardOnly : false,
      }, () => {
        this.getAgentData();
      })
    }

    let tokenData = document.getElementById('tokenData').value != null ? document.getElementById('tokenData').value : '';
    this.setState({callCenterAgentName: agentData.CallCenterAgentName ? agentData.CallCenterAgentName : null , token: tokenData})

  }

  handleAgencySpanToggle() {
    let status = !this.state.showAgencySpan
    let agentSpanStatus = this.state.agentSpanStatus
    this.setState({showAgencySpan: status, showAgentSpan: agentSpanStatus});
  }
  onAgencyChange(e) {

    this.setState((prevState) => {
      if((prevState.agencyPhone == undefined || prevState.agencyPhone == null) || prevState.agencyPhone !== e.target.value) {
        return { loadData: true, agencyPhone: e.target.value }
      } else {
        return { loadData: false, agencyPhone: e.target.value }
      }
    })
    if(e.target.value == "") {
     
      document.body.classList.add('overflow-hidden');
      this.setState({showDimmer: true, showAgencySpan: false})
    }

   // this.setState({ agencyPhone: e.target.value })
  }

  resetAgentBooking() {

    let xmlXhr = null;

    if (xmlXhr !== null) {
      xmlXhr.abort();
    }

    /* Cancel agent request */
    if (xhr !== null) {
      xhr.abort();
      this.setState({ loadingModel: false })
    }
    /* Cancel Request Change */
    
    return new Promise((resolve, reject) => {
      xmlXhr = new XMLHttpRequest();

      let baseUrl = '';
      if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
        baseUrl = document.getElementById('baseUrl').value;
      }

      xmlXhr.open('POST', `${baseUrl}/api/resetCallCenterAgent`, false);

      xmlXhr.onload = () => {

        if (xmlXhr.status >= 200 && xmlXhr.status < 300) {            
          
          const data = JSON.parse(xmlXhr.response);

          colourOptions = null
          this.setState({
              agentName: null, selectedAgent: null, agencyPhone: '', 
              showDimmer: true,
              showAgencySpan: false,
              showAgentSpan: false,
              agentOptions: null 
            }, () => {
              document.body.classList.add('overflow-hidden');
            })
          
          resolve(data);
        } else {
          reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
        }
      };
      xmlXhr.onerror = () => {
        reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
      };
      xmlXhr.send();
    });
  }

  retreiveBooking(token, language, travelbrandOrganizationId) {
    this.resetAgentBooking();
    const {
      packagURL,
      isRetreiveBooking
    } = this.state;

    const agent = document.getElementById('AccountData').getAttribute('value');
    let agentData = null;
    if (agent !== '' && agent !== null) {
      agentData = JSON.parse(agent);
    }

    let baseUrl = '';
    if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
      baseUrl = document.getElementById('baseUrl').value;
    }

    if(isRetreiveBooking == 'Y') {
      window.location.href = packagURL+'/bookingList/'+travelbrandOrganizationId+'?t='+token+'&localeLang='+language+'&organizationId='+travelbrandOrganizationId;            
    } else {
      const url = `${baseUrl}/api/setSession`;
      fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            token,
            agentUserName: agentData.CallCenterAgentName
          }),
          headers: {
              'Content-Type': 'application/json',
          },
      })
        .then((response) => response.json())
        .then((data) => {
          if(data.redirectUrl !== undefined) {
            window.location.href = data.redirectUrl+'?t='+token+'&localeLang='+language+'&organizationId='+travelbrandOrganizationId; 
            // const returl =  `${baseUrl}/api/retreiveBooking/${token}`;
            // fetch(returl, {
            //   method: 'GET',
            //   headers: {
            //     'Content-Type': 'application/json',
            //   },
            // })
            //   .then((retResponse) => retResponse.json())
            //   .then((retData) => {
            //     window.location.href = retData.redirectUrl+'?t='+token+'&localeLang='+language+'&organizationId='+travelbrandOrganizationId;            
            //   });
          } 
        });
    }
  }

  getSessionData() {

    let xmlXhr = null;

    if (xmlXhr !== null) {
      xmlXhr.abort();
    }

    return new Promise((resolve, reject) => {
      xmlXhr = new XMLHttpRequest();

      let baseUrl = '';
      if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
        baseUrl = document.getElementById('baseUrl').value;
      }


      xmlXhr.open('GET', `${baseUrl}/api/getUpdatedSession`, false);

      xmlXhr.onload = () => {

        if (xmlXhr.status >= 200 && xmlXhr.status < 300) {
          const agentData = JSON.parse(xmlXhr.response);
          
          if (agentData !== '' && agentData !== undefined && agentData.AgentSelected === 'Y') {
            
            this.setState({
              organizationId: agentData.OrganizationId ? agentData.OrganizationId : null,
              agencyId: agentData.Agency.id ? agentData.Agency.id : null,
              agencyPhone: agentData.Agency.phone ? agentData.Agency.phone : null,
              agencyName: agentData.AgencyName ? agentData.AgencyName : null,
              showDimmer: false,
              showAgencySpan: true,
              selectedAgent: {
                value: agentData.AgentId, label: `${agentData.Names.first} ${agentData.Names.last}`,
                commissionGroupCode: agentData.CommissionGroupCode ? agentData.CommissionGroupCode : null,
                chain: agentData.Chain ? agentData.Chain : null
              }
            }, () => {
              this.getAgentData();
              document.body.classList.remove('overflow-hidden');
            })
          }


          resolve(data);
        } else {
          reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
        }
      };
      xmlXhr.onerror = () => {
        reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
      };
      xmlXhr.send();
    });
  }

  getAgencyData(e) {

    if (this.state.loadData == false && this.state.agencyPhone != '') {
      //alert("Dd")
      this.setState({showAgencySpan: true})
      return;
    }

    const filter = e.target.value

    if (filter != null && filter != '') {
      document.body.classList.remove('overflow-visible');
      document.body.classList.add('overflow-hidden');
    } else if (this.state.isRetreiveBooking == 'Y') {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.add('overflow-visible');
    } else {
      /* Commented on 14 Jun */
      // document.body.classList.remove('overflow-visible');
      // document.body.classList.add('overflow-hidden');
      /* Comment end */
      
      colourOptions = null
      this.setState({
          agentName: null, selectedAgent: null, agencyPhone: '', 
          showDimmer: true,
          showAgencySpan: false,
          showAgentSpan: false,
          agentOptions: null 
        }, () => {
          document.body.classList.remove('overflow-visible');
          document.body.classList.add('overflow-hidden');
        })
    }

    if (filter != null && filter != '') {
      let CityXHR = null;

      if (CityXHR !== null) {
        CityXHR.abort();
      }


      return new Promise((resolve, reject) => {
        CityXHR = new XMLHttpRequest();

        let baseUrl = '';
        if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
          baseUrl = document.getElementById('baseUrl').value;
        }


        CityXHR.open('GET', `${baseUrl}/api/getAgencyAutoSearch/${filter}`);

        CityXHR.onload = () => {

          if (CityXHR.status >= 200 && CityXHR.status < 300) {
            const data = JSON.parse(CityXHR.response);
            if (data != '') {

              this.setState({
                agencyData: data, organizationId: data['0']['organizationId'], agencyId: data['0']['value'], agencyName: data['0']['label'],
                commissionGroupCode: data['0']['commissionGroupCode'], chain: data['0']['chain'] , loadData: false, showAgencySpan: true,
                chainName: data['0']['chain']['name'],
                agencyPIN: data['0']['agencyPIN'],
                fopCreditCardOnly: data['0']['fopCreditCardOnly']
              }, () => {
                this.getAgentData();
              });
            } else {
              this.setState({agentOptions: null }) 
            }
            resolve(data);
          } else {
            reject(`status: ${CityXHR.status}, statusText: ${CityXHR.statusText}`);
          }
        };
        CityXHR.onerror = () => {
          reject(`status: ${CityXHR.status}, statusText: ${CityXHR.statusText}`);
        };
        CityXHR.send();
      });
    }
  };

  
  getAgentData(e) {

    this.setState({ loadingModel: true });
    
    if (xhr !== null) {
      xhr.abort();
    }

    return new Promise((resolve, reject) => {
      xhr = new XMLHttpRequest();
      let organizationId = this.state.organizationId
      let agencyId = this.state.agencyId


      let baseUrl = '';
      if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
        baseUrl = document.getElementById('baseUrl').value;
      }



      xhr.open('GET', `${baseUrl}/api/getAgentByAgency?organizationId=${organizationId}&agencyId=${agencyId}`);

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const data = JSON.parse(xhr.response);
          colourOptions = data;
          this.setState({ loadingModel: false, agentOptions: data, organizationId: organizationId, agencyId: agencyId })          
          if (this.state.showAgentSpan == true) {
            document.body.classList.remove('overflow-hidden');
          }
          resolve(data);

        } else {
          reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        }
      };
      xhr.onerror = () => {
        reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
      };
      xhr.send();
    });
  };

  handleAgentChange(e) {

    if (e) {
      this.setState({ agentName: e ? e.label : "", showModal: true, selectedAgent: { value: e ? e.value : "", label: e ? e.label : "" } })        
    } else {
      
      this.setState({ agentName: null, selectedAgent: null, showDimmer: true })
      document.body.classList.add('overflow-hidden');
      
    }
  }
  closeModal(e) {
    this.setState({ showModal: false, agentName: null, selectedAgent: null , showDimmer: true })
    document.body.classList.add('overflow-hidden');

  }

  createAgentSession(e) {


    let agencyName = this.state.agencyName
    let commissionGroupCode = this.state.commissionGroupCode
    let chain = this.state.chain
    let agencyPIN = this.state.agencyPIN
    let fopCreditCardOnly = this.state.fopCreditCardOnly
    let language = this.state.language;
    let baseUrl = '';
    if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
      baseUrl = document.getElementById('baseUrl').value;
    }

    const token = document.getElementById('tokenData').value != null ? document.getElementById('tokenData').value : '';

    /** set isRetrive N */

    let xmlXhr = null;
    if (xmlXhr !== null) {
      xmlXhr.abort();
    }

    return new Promise((resolve, reject) => {
      xmlXhr = new XMLHttpRequest();
      xmlXhr.open('GET', `${baseUrl}/api/updateRetreiveBooking/${token}`, false);
      xmlXhr.onload = () => {
        if (xmlXhr.status >= 200 && xmlXhr.status < 300) {            
          const data = JSON.parse(xmlXhr.response);

          window.location = `${baseUrl}/getAgentForCallCenter?organizationId=${this.state.organizationId}&agentId=${this.state.selectedAgent.value}&agencyName=${agencyName}
          &commissionGroupCode=${commissionGroupCode}&chain=${JSON.stringify(chain)}&agencyPIN=${agencyPIN}&fopCreditCardOnly=${this.state.fopCreditCardOnly}&token=${token}&language=${language}`
    
          resolve(data);
        } else {
          reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
        }
      };
      xmlXhr.onerror = () => {
        reject(`status: ${xmlXhr.status}, statusText: ${xmlXhr.statusText}`);
      };
      xmlXhr.send();
    });

 
  }

  render() {
    const { agencyName, showAgentSpan, showAgencySpan, agencyPhone, agentOptions, showModal, agentName, selectedAgent, loadingModel, language, callCenterAgentName, showDimmer, packagURL, fopCreditCardOnly, token, travelbrandOrganizationId, redirectedRoute, isRetreiveBooking, urlArray } = this.state;
    
    let chainName = (this.state.chainName != undefined && this.state.chainName != null) ? `CHAIN: ${this.state.chainName}` : ''
    let agencyPIN = (this.state.agencyPIN != undefined && this.state.agencyPIN != null) ? `PIN: ${this.state.agencyPIN}` : ''
    let agentlabel = (selectedAgent?.label != undefined && selectedAgent?.label != null) ? selectedAgent.label : '' 
    console.log(fopCreditCardOnly)
    const agent = document.getElementById('AccountData').getAttribute('value');
    let agentDetail = null;
    if (agent !== '' && agent !== null) {
        agentDetail = JSON.parse(agent);
    }

    const {
      pathname
    } = window.location;

    return (
      <>
     

        <div className="py-2 callcenter-header-bar">
          <div className="container">
            <div className="row gutter-10 align-items-center justify-content-between">
              
              <div class="col-xxl-7 col-xl-8 col-lg-8 col-md-5 col-md-6 col-sm-12 col mb-md-0">
                <div className="d-lg-flex flex-xl-nowrap flex-wrap align-items-xl-center">
                  <label className="mb-2 mb-xl-0 text-white text-md-right font-size-md text-nowrap col-12 col-md-auto font-weight-500 p-0">{Lang.trans('callcenter.booking_on_behalf_of')}</label>
                  <div className="d-lg-flex col p-0 col-lg-10 col-xl">
                    <div className="mb-lg-0 ml-xl-2 mr-lg-2">
                      <div className="element-wrapper">
                        <div>
                    { showAgencySpan ? 
                      <div role='button' title='Click to edit' onClick={this.handleAgencySpanToggle} class={`text-white font-size-sm`} >
                        <div className="text-nowrap">
                          {`${agencyName} - ${agencyPhone}`}
                        </div>
                        <div className="text-nowrap mt-1">
                          {`${agentlabel}`}
                        </div>
                        <div className="text-nowrap mt-1">
                          {`${chainName}`} {`${agencyPIN}`}
                          {fopCreditCardOnly && 
                            <svg title="High risk agency - CC only" className="icon mr-0 fill-red pr-0 ml-1 pt-1" aria-hidden="true">
                              <title>{Lang.trans('callcenter.high_risk_agency')}</title>
                              <use xmlnsXlink="http://www.w3.org/2000/svg" xlinkHref="/img/icons/icon-defs.svg#icon-alert" />
                            </svg> 
                          }
                        </div>
                      </div>
                     : 
                      <input
                        isClearable
                        className="form-control text-white bg-transparent rounded-sm border shadow-none agency-number"
                        value={agencyPhone}
                        placeholder={Lang.trans('callcenter.type_agency_here')}
                        onChange={this.onAgencyChange}
                        onBlur={this.getAgencyData}
                      /> 
                    }



                        </div>
                      </div>
                    </div>

                    

              {!showAgentSpan && <div className="element-wrapper w-100 agent-selectpicker d-flex align-items-center mt-2 mt-lg-0">
                      <div class="element-container agent-name">
                        <AsyncSelect
                          ref={ref => {
                            this.selectRef = ref;
                          }}
                         // cacheOptions
                          isClearable
                          className="selectpicker form-control bg-transparent p-0 border-0 rounded-sm border shadow-none"
                          value={selectedAgent}
                          placeholder={Lang.trans('callcenter.select_agent_here')}
                          defaultOptions={agentOptions}
                          loadOptions={promiseOptions}
                          noOptionsMessage={() => Lang.trans('callcenter.no_agent_found')}
                          loadingMessage={() => Lang.trans('callcenter.no_agent_found')}
                          onChange={this.handleAgentChange}

                        />
                      </div>
                    </div> }
                  </div>
                  
                

                </div>
              </div>
              <div className="col-xxl-5 col-lg-4 col-md-6 text-right mt-2 mt-md-2 mt-lg-0">
                <div className="d-flex align-items-center justify-content-end pl-5">
                  <button class="border-0 btn btn-primary font-size-sm font-weight-500" onClick={this.resetAgentBooking}>  {(language == 'en' || language == '') ? 'New Booking' : 'Nouvelle réservation'}</button>
                  <button class="border-0 btn btn-primary font-size-sm font-weight-500 ml-2" onClick={(e) => this.retreiveBooking(token, language, travelbrandOrganizationId)}>  {(language == 'en' || language == '') ? 'Retrieve Booking' : 'Récupérer réservation'}</button>
                  <div className="dropdown">
                    <div className="text-white font-size-md ml-3">
                      {language == 'fr' ? "Bonjour" : "Hello"}, {callCenterAgentName}
                    </div>
                    <div class="dropdown-menu profile-dropdown border-0 rounded w-100 position-absolute font-size-md mt-3" aria-labelledby="dropdownMenuButton">
                      <div class="p-3">
                        <ul class="list-unstyled pb-0 mb-0">
                          { showAgentSpan == true && (
                            <li className="mb-2"><a role="button" onClick={(e) => this.retreiveBooking(token, language, travelbrandOrganizationId)} /* href={packagURL+'/bookingList?t='+token+'&localeLang='+language+(agentDetail !== null && agentDetail.newBooking && agentDetail.newBooking == true ? '&newBooking=true' : '')} */ class="primary-color font-weight-500 pb-0">{(language == 'en' || language == '') ? 'Modify Booking' : 'Modifier la réservation'}</a></li>
                          )}
                          <li><a href={language == 'fr' ? "/fr/logout" : "/logout"} class="primary-color font-weight-500 pb-0">Sign out</a></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                  </div>

                </div>

            </div>
          </div>
        </div>

        {/* { showDimmer && <div class="callcenter-overlay"></div> } */}

        { urlArray.includes(pathname) ?
          <>{ showDimmer && <div class="callcenter-overlay"></div> }</>
        :
          <>
            {(isRetreiveBooking == 'Y' && showAgencySpan == false) ? null : <>{ showDimmer && <div class="callcenter-overlay"></div> }</> }
          </>
        }

        {loadingModel && <div class="callcenter-overlay text-center">
        <div className="d-flex h-100 align-items-center justify-content-center flex-column">
                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" widht="100px" height="100px" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xmlSpace="preserve">
                  <circle fill="#e8b11f" stroke="none" cx="6" cy="50" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"></animate></circle>
                  <circle fill="#6ca948" stroke="none" cx="26" cy="50" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"></animate></circle>
                  <circle fill="#ab2620" stroke="none" cx="46" cy="50" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"></animate></circle>
                  <circle fill="#2a82c5" stroke="none" cx="66" cy="50" r="6"><animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"></animate></circle>
                </svg>
                <h5 className="text-white"> {Lang.trans('callcenter.fetching_data')}</h5>
            </div>
        </div> }

        <Modal show={showModal} centered dialogClassName="my-3 ml-auto mr-auto px-4">
          <div className="shadow-none border-top-thick-red">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="p-4">
                  <div className="row">

                    <div className="col-md-12">
                      <p className="mt-3 text-dark font-weight-500 mb-0">
                        {Lang.trans('callcenter.do_you_want_to')} <br/> {agentName}
                      </p>
                    </div>
                    <div className="col-md-12 mt-4">
                      <button ref={(ref) => { this.okBtn = ref; }} className="btn-secondary px-4 py-2 btn text-white font-weight-500 mx-1" onClick={this.createAgentSession}>
                      {Lang.trans('callcenter.ok')}
                      </button>
                      <button ref={(ref) => { this.okCncl = ref; }} className="btn-secondary px-4 py-2 btn text-white font-weight-500 mx-1" onClick={this.closeModal}>
                      {Lang.trans('callcenter.CANCEL')}
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }
}

export default CallCenterHeader;
